"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const SelectionWrapper = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "SelectionList__SelectionWrapper",
  componentId: "sc-1kx9lqi-0"
})([".SelectionListItem:first-of-type{border-top-left-radius:4px;border-top-right-radius:4px;}.SelectionListItem:not(:last-of-type){border-bottom:0;}.SelectionListItem:last-of-type{border-bottom-left-radius:4px;border-bottom-right-radius:4px;}"]);

const removeFrom = (arr, value) => arr.filter(item => item !== value);

const mergeInto = (arr, value) => removeFrom(arr, value).concat(value);

const SelectionList = ({ values = [], onChange, children, readonly }) => {
  let selecteds = {};

  let newChildren = _react2.default.Children.map(children, child => {
    let isChecked = false;
    if (child.props && values.includes(child.props.value)) {
      selecteds[child.props.value] = true;
      isChecked = true;
    }

    return _react2.default.cloneElement(child, {
      checked: isChecked,
      onChange: e => {
        if (!readonly && (0, _lodash.isFunction)(onChange)) {
          onChange(e.target.checked ? mergeInto(values, child.props.value) : removeFrom(values, child.props.value));
        }
      }
    });
  });

  (0, _react.useEffect)(() => {
    if ((0, _lodash.isFunction)(onChange)) {
      onChange(Object.keys(selecteds));
    }
  }, []);

  return _react2.default.createElement(
    SelectionWrapper,
    null,
    newChildren
  );
};

SelectionList.propTypes = {
  values: _propTypes2.default.array.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node,
  readonly: _propTypes2.default.bool
};

exports.default = SelectionList;